import { useEffect, useState } from 'react';

/** A `blob:` URL showing `file` while the component shows it, released after. */
export function useObjectUrl(file: File | null | undefined): string | undefined {
  const [url, setUrl] = useState<string>();
  useEffect(() => {
    if (!file) {
      setUrl(undefined);
      return;
    }
    const made = URL.createObjectURL(file);
    setUrl(made);
    return () => URL.revokeObjectURL(made);
  }, [file]);
  return url;
}
